import { AddressDeliveryType } from "../../../models/transportation/enums/addressDeliveryType";
import { ValidateProperty } from "../../../models/utilities/validate-property";

export class DeliveryAddressUpdate {
    
    public rowVersion : string = '';

    @ValidateProperty({ required: true })
    public unloadRate : number|undefined = undefined;
    
    @ValidateProperty({ required: true })
    public latitude : number|null = null;
    
    @ValidateProperty({ required: true })
    public longitude : number|null = null;
    
    @ValidateProperty({ required: true })
    public timeZoneId : string = '';
    
    @ValidateProperty({ required: true })
    public country : string = '';

    @ValidateProperty({ minChildren: 1 })
    public deliveryHours: DeliveryHourUpdate[] = [];

    public phoneNumber: string = '';

    public contactEmailBusiness: string | null = null;

    public contactNameBusiness: string | null = null;

    public contactPhoneNumberBusiness: string | null = null;

    public contactEmailSite: string | null = null;

    public contactNameSite: string | null = null;

    public contactPhoneNumberSite: string | null = null;

    public note: string | null = null;

    public deliveryTypes: AddressDeliveryType[] = [];

    public isJobSite: boolean = false;

    public name: string | null = null;

    public addressLine1: string | null = null;

    public addressLine2: string | null = null;

    public city: string | null = null;

    public stateProvince: string | null = null;

    public postalCode: string | null = null;

    public isReviewed: boolean = false;

    public force: boolean = false;
}

export class DeliveryHourUpdate {

    // public id : number = 0;

    // public deliveryAddressId : number = 0;

    public weekDays: number;

    public startTime: string = '';

    public endTime?: string = '';

    // public uniqueID : string = '';
}
